// src/pages/Dashboard.jsx
import React from "react";
import "../styles/Dashboard.css";

const Dashboard = () => {
  return (
    <div className="dashboard-container">
      <h1>Welcome to Loyola eNotes Admin Dashboard 🎓</h1>
      <p>Manage your Departments and Programs efficiently.</p>
    </div>
  );
};

export default Dashboard;
